import $ from 'jquery';
import whatInput from 'what-input';
import fitty from 'fitty';

window.$ = $;

//import Foundation from 'foundation-sites';
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './lib/foundation-explicit-pieces.js';

$(document).foundation();

// Use this to get the dynamic calc of any element on load
function calculateHeight() {
  const siteheader = document.getElementById('site-header')?.offsetHeight || 0;
  const aoctext = document.getElementById('aoc-text')?.offsetHeight || 0;

  document.documentElement.style.setProperty('--siteheader', `${siteheader}px`);
  document.documentElement.style.setProperty('--aoctext', `${aoctext}px`);

  document.querySelectorAll('.thumbnails-view').forEach(row => {
    const large4 = row.querySelector('.alm-item.large-4');
    if (!large4) return;

    const info = large4.querySelector('.info.setter');
    if (!info) return;

    const height = info.offsetHeight;
    row.style.setProperty('--info', `${height}px`);
  });
}

window.addEventListener('load', () => setTimeout(calculateHeight, 10));
window.addEventListener('resize', calculateHeight);
window.addEventListener('orientationchange', calculateHeight);

window.almComplete = function(alm) {
  //console.log('Loaded ALM instance:', alm);
  requestAnimationFrame(() => setTimeout(calculateHeight, 0));
};




//Off Canvas scroll lock
function preventDefault(e){
    e.preventDefault();
}

$(window).on('opened.zf.offCanvas', function() {
    document.body.addEventListener('touchmove', preventDefault, { passive: false });
    $('html, body').toggleClass('offcanvas-active');
});

$(window).on('close.zf.offCanvas', function() {
    document.body.removeEventListener('touchmove', preventDefault);
    $('html, body').toggleClass('offcanvas-active');
});

function setSessionCookie(name, value) {
    document.cookie = name + "=" + value + "; path=/";
}

function getCookie(name) {
    const decoded = decodeURIComponent(document.cookie);
    const ca = decoded.split(';');
    name = name + "=";
    for (let c of ca) {
        while (c.charAt(0) === ' ') c = c.substring(1);
        if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
    }
    return "";
}

document.addEventListener('DOMContentLoaded', function() {

    const aoc = document.getElementById('aoc');

    function closeAOC() {
        aoc.classList.add('hide'); // Foundation helper: display: none
        aoc.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('aoc-lock');
        document.body.classList.remove('aoc-lock');
        setSessionCookie('aocAcknowledged', 'true'); // session cookie, no expiry
    }

    if (!getCookie('aocAcknowledged')) {
        aoc.classList.remove('hide'); // show it
        aoc.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('aoc-lock');
        document.body.classList.add('aoc-lock');

        // Click anywhere on overlay
        aoc.addEventListener('click', function() {
            closeAOC();
        });

        // Press Escape key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') {
                closeAOC();
            }
        });
    }

    // Listen for a click on any thumbnail filter radio
    document.querySelectorAll('#alm-filters-project_types_thumbnails .alm-filter--link.field-radio').forEach(function (radio) {
        radio.addEventListener('click', function () {
            const isActive = this.classList.contains('active');
            const value = isActive ? '' : this.getAttribute('data-value');
            ajaxloadmore.filter('fade', 300, {
                target: 'list',
                tag: value
            });
        });
    });

    // --- View toggle buttons ---
    document.querySelectorAll('.view-toggle button').forEach(function (btn) {
        btn.addEventListener('click', function () {
            const view = btn.getAttribute('data-view');

            document.querySelectorAll('.view-toggle button').forEach(function (b) {
                b.classList.remove('active');
            });
            btn.classList.add('active');

            if (view === 'thumbnails') {
                document.querySelector('.thumbnails-view-mode').style.display = 'block';
                document.querySelector('.list-view-mode').style.display = 'none';
            } else {
                document.querySelector('.thumbnails-view-mode').style.display = 'none';
                document.querySelector('.list-view-mode').style.display = 'block';
            }
        });
    });

    // --- Splide setup for all sliders ---
    document.querySelectorAll('.splide').forEach((splideEl) => {
        if (typeof Splide !== 'undefined') {
            const splide = new Splide(splideEl, JSON.parse(splideEl.dataset.splide || '{}'));

            // Special logic only for the homepage hero slider
            if (splideEl.classList.contains('project-slider')) {
                const heroButtons = document.querySelectorAll('.button-group .button');
                let lottieDirection = 1; // 1 = forward, -1 = backward

                splide.on('mounted move', () => {
                    const index = splide.index;
                    const totalButtons = heroButtons.length;
                    const buttonsPerGroup = 4;
                    const group = Math.floor(index / buttonsPerGroup);
                    const start = group * buttonsPerGroup;
                    const end = start + buttonsPerGroup;
                    heroButtons.forEach((btn, i) => {
                        const inGroup = i >= start && i < end;
                        btn.style.display = inGroup ? 'block' : 'none';
                        btn.classList.toggle('is-active', i === index);
                    });
                    // Lottie alternate direction
                    const lottieEl = document.querySelector('#hero .lottie');
                    if (lottieEl && lottieEl._lottie) {
                        const anim = lottieEl._lottie;
                        anim.stop();
                        anim.setDirection(lottieDirection);
                        const startFrame = lottieDirection === -1
                            ? anim.totalFrames - 1
                            : 0;
                        anim.goToAndStop(startFrame, true);
                        anim.play();
                        lottieDirection *= 1; // adjust if you want it to flip (currently always 1)
                    }
                });
            }
            splide.mount();
        }
    });

    function countUp(el, end, duration = 1500) {
        const suffix = el.dataset.suffix || ''; // fallback to empty if no suffix
        const startTime = performance.now();

        function update(currentTime) {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const value = Math.floor(progress * end);

            el.textContent = value.toLocaleString() + suffix;

            if (progress < 1) {
                requestAnimationFrame(update);
            }
        }

        requestAnimationFrame(update);
    }

    const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
        const el = entry.target;
        const target = parseInt(el.dataset.target, 10);
        if (!isNaN(target)) {
            countUp(el, target);
            obs.unobserve(el); // run only once
        }
        }
    });
    }, {
    threshold: 0.4, // trigger when 40% visible (tweak as needed)
    });

    document.querySelectorAll('.count-up').forEach(el => { observer.observe(el); });

    // --- Lottie animations ---
    if (typeof lottie !== 'undefined') {
        document.querySelectorAll('.lottie').forEach(function (el) {
            let settings = {};
            try {
                settings = JSON.parse(el.dataset.lottie || '{}');
            } catch (e) {
                console.warn('Invalid JSON in data-lottie:', el.dataset.lottie, e);
                return;
            }
            if (!settings.src) {
                console.warn('Missing `src` in data-lottie for element:', el);
                return;
            }
            const anim = lottie.loadAnimation({
                container: el,
                renderer: 'svg',
                loop: settings.loop ?? true,
                autoplay: settings.autoplay ?? true,
                path: settings.src,
            });
            el._lottie = anim;
        });
    }

    const fittyOptions = {
        minSize: 18,
        maxSize: 115,
        multiLine: false,
        observeMutations: {
            childList: true
        }
    };

    let fittyInstances = [];

    const destroyFitty = () => {
        fittyInstances.forEach(instance => instance.unsubscribe?.());
        fittyInstances = [];
    };

    const initFitty = () => {
        const initResult = fitty('.fit', fittyOptions);
        fittyInstances = (Array.isArray(initResult) ? initResult : (initResult ? [initResult] : [])).filter(Boolean);
    };

    initFitty();

    const refitHeadings = () => {
        if (!fittyInstances.length) {
            initFitty();
        }
        fittyInstances.forEach(instance => {
            instance.dirty = true;
            instance.fit();
        });
    };

    let rafId = null;
    const scheduleRefit = () => {
        if (rafId !== null) {
            cancelAnimationFrame(rafId);
        }
        rafId = requestAnimationFrame(() => {
            rafId = null;
            refitHeadings();
        });
    };

    window.addEventListener('resize', scheduleRefit);
    window.addEventListener('orientationchange', scheduleRefit);
    if (window.jQuery && typeof window.jQuery === 'function') {
        window.jQuery(window).on('changed.zf.mediaquery', scheduleRefit);
    }
    if ('ResizeObserver' in window) {
        const headerBar = document.querySelector('#site-header .title-bar');
        if (headerBar) {
            const headerObserver = new ResizeObserver(scheduleRefit);
            headerObserver.observe(headerBar);
        }
        const center = document.querySelector('.title-bar-center');
        if (center) {
            let lastWidth = center.getBoundingClientRect().width;
            const centerObserver = new ResizeObserver(entries => {
                const width = entries[0]?.contentRect.width;
                if (typeof width === 'number') {
                    const growing = width > lastWidth + 0.5;
                    lastWidth = width;
                    if (growing) {
                        destroyFitty();
                        initFitty();
                    }
                    scheduleRefit();
                }
            });
            centerObserver.observe(center);
        }
    }
    if (document.fonts && typeof document.fonts.ready?.then === 'function') {
        document.fonts.ready.then(refitHeadings);
    }
    // run immediately and once more on next tick to capture late layout shifts
    refitHeadings();
    setTimeout(refitHeadings, 150);
});
